import React from 'react';
import StudentLayout from './components/StudentLayout';
import RecordingsPage from '../shared/RecordingsPage';

const StudentRecordings = () => (
  <RecordingsPage
    LayoutComponent={StudentLayout}
    title="Recordings"
    description="Completed sessions you attended and their recording readiness."
  />
);

export default StudentRecordings;
